import { Calendar } from '../schema/Calendar';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getEventToCalendarAssociation } from '../utils/getEventToCalendarAssociation';

/**
 * Function which gets the calendar to which a particular event belongs
 * @param event
 */
export function getCalendarForCalendarEvent(event: CalendarEvent): Calendar {
    if (!event) {
        return null;
    }
    const { ParentFolderId } = event;
    const association = getEventToCalendarAssociation();
    if (!association) {
        return null;
    }
    const { folderIdToCalendarIdMapping, calendarIdToCalendarMapping } = association;
    const calendarId = ParentFolderId ? folderIdToCalendarIdMapping.get(ParentFolderId.Id) : null;
    return calendarId ? calendarIdToCalendarMapping.get(calendarId.id) : null;
}
